import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { default as MaterialCard } from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    minHeight: '200px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    backgroundColor: '#2952CC',
  },
  cardIcon: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flexGrow: 1,
  },
  cardFooter: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '12px',
  },
  cardFooterText: {
    display: 'flex',
    justifyContent: 'center',
    color: 'white',
  },
}));

interface CardProps {
  /**
   * Maximum width of the card
   */
  maxWidth: string;
  /**
   * What background color to use
   */
  backgroundColor: string;
  /**
   * Icon displayed on the card
   */
  iconUri: string;
  /**
   * Text label for the card
   */
  label: string;
  /**
   * Click handler
   */
  onClick: () => void;
}

export const Card = ({
  backgroundColor,
  maxWidth,
  label,
  iconUri,
  ...props
}: CardProps) => {
  const classes = useStyles();

  return (
    <MaterialCard
      {...props}
      className={classes.cardContainer}
      style={{
        backgroundColor: backgroundColor,
      }}
    >
      <div className={classes.cardIcon}>
        <img src={iconUri} alt="Icon" style={{ height: 80 }} />
      </div>
      <footer className={classes.cardFooter}>
        <Typography className={classes.cardFooterText}>{label}</Typography>
      </footer>
    </MaterialCard>
  );
};

Card.defaultProps = {
  maxWidth: '200px',
  backgroundColor: '#2952CC',
  iconUri: '/images/check-in-v2.svg',
  label: 'Check-In',
  onClick: undefined,
};
